(function () {
  function isoToFlagEmoji(iso) {
    if (!iso || iso.length !== 2) return '';
    return iso
      .toUpperCase()
      .replace(/./g, function (char) {
        return String.fromCodePoint(127397 + char.charCodeAt(0));
      });
  }

  function applyFlags(root) {
    (root || document).querySelectorAll('[data-flag]:not([data-flag-applied])').forEach(function (el) {
      var flag = isoToFlagEmoji(el.getAttribute('data-flag'));
      if (flag) {
        el.textContent = flag;
        el.setAttribute('data-flag-applied', 'true');
      }
    });
  }

  applyFlags();

  /* Re-apply after theme-editor section reloads */
  document.addEventListener('shopify:section:load', function (event) {
    applyFlags(event.target);
  });
})();
